/**
 * Authentication constants for App Router middleware
 *
 * Note: Currently using localStorage-based tokens (not httpOnly cookies yet)
 * Middleware will check for tokens via request headers or cookies
 */

export const AUTH_CONSTANTS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
} as const;

/**
 * Public routes that don't require authentication
 */
export const PUBLIC_ROUTES = [
  '/auth/login',
  '/auth/logout',
  '/accounts/forgot-password',
  '/accounts/confirm',
  '/accounts/unsubscribe',
  '/api', // API routes
] as const;

/**
 * Routes that require authentication
 */
export const PROTECTED_ROUTES = [
  '/search',
  '/profiles',
  '/territories',
  '/lists',
  '/settings',
  '/analytics',
  '/strategy-center',
  '/activity',
  '/exports',
  '/manager',
  '/rep',
  '/patient-journey',
  '/global-reports',
] as const;

/**
 * Admin-only routes (superuser or support user)
 */
export const ADMIN_ROUTES = [
  '/settings/admin',
] as const;

/**
 * Company-scoped routes
 */
export const COMPANY_ROUTES = [
  '/settings/company',
] as const;

/**
 * Build the API login URL. In non-production environments, appends a `returnTo`
 * param so the API redirects back to the current origin after Auth0
 * authentication instead of defaulting to the production frontend.
 */
export function buildApiLoginUrl(): string {
  const loginUrl = `${process.env.NEXT_PUBLIC_API_URL}v1/admin/login`;
  if (process.env.NEXT_PUBLIC_TARGET_ENV?.toLowerCase() !== 'production') {
    const returnTo = encodeURIComponent(`${window.location.origin}/auth/login`);
    return `${loginUrl}?returnTo=${returnTo}`;
  }
  return loginUrl;
}
